<template>
  <v-container>
    <sub-navigation></sub-navigation>
    <v-layout row wrap>
      <div class="custom-scrollbar">
      <v-card class="pt-3 pr-0 pl-0 pb-1 elevation-1 transparent" :class="{'pr-3 pl-3': $vuetify.breakpoint.smAndUp}">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <h2>Osobní údaje</h2>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm6>
              <div class="right">
                <v-btn color="primary" v-if="!editMode" @click="editClick" class="elevation-0 ml-2">
                  <v-icon small class="mr-2">edit</v-icon>
                  Upravit
                </v-btn>
                <v-btn color="red" flat @click="removeClick">
                  <v-icon small class="mr-2">delete</v-icon>
                  Smazat
                </v-btn>
                <v-menu offset-y>
                  <v-btn outline color="primary" slot="activator"><v-icon class="mr-2" small>people</v-icon> Spolupracovník</v-btn>
                  <v-list>
                    <v-list-tile @click="spolupracovnikClick">
                      <v-list-tile-title>
                        Stát se spolupracovníkem
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12 sm6 md3 v-if="item.typ_osoby=='po'">
              <p class="grey--text caption mb-1">Název firmy:</p>
              <strong v-if="item.nazev_firmy != null">{{item.nazev_firmy}}</strong><span v-else>--</span>
            </v-flex>
            <v-flex xs12 sm6 md3 v-if="item.typ_osoby=='osvc' || item.typ_osoby=='fo'">
              <p class="grey--text caption mb-1">Jméno a příjmení:</p> <strong>{{item.nazev_osoby}}</strong>
            </v-flex>
            <v-flex xs12 sm6 md3 v-if="item.typ_osoby=='po' || item.typ_osoby=='osvc'">
              <p class="grey--text caption mb-1">IČ:</p> <strong>{{item.ic}}</strong>
            </v-flex>
            <v-flex xs12 sm6 md3 v-if="item.typ_osoby=='po' || item.typ_osoby=='osvc'">
              <p class="grey--text caption mb-1">DIČ:</p>
              <strong v-if="item.dic != null">{{item.dic}}</strong><span v-else>--</span>
            </v-flex>
            <v-flex xs12 sm6 md3 v-if="item.klient">
              <p class="grey--text caption mb-1">Je tipař:</p> <strong v-if="item.je_tipar">Ano</strong><strong v-else>--</strong>
              <strong v-else>Ne</strong>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Datum narození:</p>
              <strong v-if="item.datum_narozeni != null">{{item.datum_narozeni | formatSimpleDate}}</strong><span v-else>--</span>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Telefon:</p>
              <strong v-if="item.telefon != null">{{item.telefon}}</strong><span v-else>--</span>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Email:</p>
              <strong v-if="item.email != null">{{item.email}}</strong><span v-else>--</span>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Kraj:</p> <strong v-if="item.kraj != null">{{item.kraj.nazev}}</strong><strong v-else>--</strong>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Způsob doručení:</p> <strong v-if="item.zpusob_doruceni != null">{{item.zpusob_doruceni.nazev}}</strong><strong v-else>--</strong>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3" v-if="item.spolupracovnik">
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Má kancelář:</p> <strong v-if="item.ma_kancelar">Ano</strong><strong v-else>--</strong>
              <strong v-else>Ne</strong>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Předání informací o ochraně osobních údajů:</p> <strong v-if="item.informovan_gdpr">Ano</strong><strong v-else>--</strong>
              <strong v-else>Ne</strong>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Certifikován:</p> <strong v-if="item.certifikovan">Ano</strong><strong v-else>--</strong>
              <strong v-else>Ne</strong>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Absolvoval certifikační schůzky u klienta:</p> <strong v-if="item.certifikacni_zkouzky">Ano</strong><strong v-else>--</strong>
              <strong v-else>Ne</strong>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-card class="pt-3 pr-3 pl-3 pb-1 mt-4 elevation-1 transparent">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <h3>Adresy</h3>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12>
              <div class="table-border__radius elevation-1">
                <v-data-table
                  :headers="headersAdresy"
                  :items="item.adresy"
                >
                  <template v-slot:items="props">
                    <td>
                      <div v-if="props.item.hlavni">Hlavní</div>
                      <div v-if="props.item.fakturacni">Fakturační</div>
                      <div v-if="props.item.dorucovaci">Doručovací</div>
                    </td>
                    <td>{{ props.item.jmeno }} {{ props.item.prijmeni }}</td>
                    <td>{{ props.item.nazev_firmy }}</td>
                    <td>{{ props.item.cela_adresa }}</td>
                    <td>{{ props.item.ic }}</td>
                    <td>{{ props.item.dic }}</td>
                    <td>{{ props.item.telefon }}</td>
                  </template>
                </v-data-table>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-card class="pt-3 pr-3 pl-3 pb-1 mt-4 elevation-1 transparent">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <h3>Bankovní účty</h3>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12>
              <div class="table-border__radius elevation-1">
                <v-data-table
                  :headers="headersBankUcty"
                  :items="item.bankovni_ucty"
                >
                  <template v-slot:items="props">
                    <td>
                      <div v-if="props.item.typ_uctu=='iban'">IBAN</div>
                      <div v-if="props.item.typ_uctu=='cz'">Český účet</div>
                    </td>
                    <td>
                      <span v-if="props.item.typ_uctu=='iban'">{{ props.item.ucet }}</span>
                      <span v-if="props.item.typ_uctu=='cz'">{{ props.item.ucet }}/{{ props.item.ucet_kod_banky }}</span>
                    </td>
                  </template>
                </v-data-table>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-card class="pt-3 pr-3 pl-3 pb-1 mt-4 elevation-1 transparent" v-if="item.spolupracovnik">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <h3>Dokumenty</h3>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12>
              <v-btn color="primary" class="elevation-0 ma-0 mr-2">
                <v-icon small class="mr-2">attachment</v-icon>
                Živnostenský list
              </v-btn>
              <v-btn color="primary" class="elevation-0 ma-0 mr-2">
                <v-icon small class="mr-2">attachment</v-icon>
                Výpis z rejstříku trestů
              </v-btn>
              <v-btn color="primary" class="elevation-0 ma-0 mr-2">
                <v-icon small class="mr-2">attachment</v-icon>
                Životopis
              </v-btn>
              <v-btn color="primary" class="elevation-0 ma-0 mr-2">
                <v-icon small class="mr-2">attachment</v-icon>
                Smlouva o obchodním zastoupení
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-layout row wrap>
        <v-flex d-flex xs12 sm6>
          <v-card class="flex-height pt-3 pl-3 pb-1 mt-4 elevation-1 transparent">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <h3>Poradce</h3>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3" v-if="item.poradce != null">
                <v-flex xs12 sm6 md4>
                  <strong><eshop-link :to="{ path: '/spolupracovnici/' + item.poradce.id }">{{item.poradce.nazev_osoby}}</eshop-link></strong>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-else>
                <v-flex xs12>
                  <p class="mt-2">Poradce není definován.</p>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex d-flex xs12 sm6>
          <v-card class="pt-3 pr-3 pb-1 mt-4 pl-0 elevation-1 transparent">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <h3>Tipař</h3>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3" v-if="item.tipar != null">
                <v-flex xs12 sm6 md4>
                  <strong><eshop-link :to="{ path: '/spolupracovnici/' + item.tipar.id }">{{item.tipar.nazev_osoby}}</eshop-link></strong>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-else>
                <v-flex xs12>
                  <p class="mt-2">Tipař není definován.</p>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
    </v-layout>
  </v-container>
</template>
<script>
  import Base from '../Base'
  export default {
    extends: Base,
    data () {
      return {
        loading: true,
        editMode: false,
        headers: [
          { text: 'Jméno', value: 'jmeno', sortable: false },
          { text: 'Město', value: 'mesto', sortable: false },
          { text: 'Telefon', value: 'telefon', sortable: false },
          { text: 'Stav el. pen. Kč', value: 'stav_penezenky_kc', sortable: false },
          { text: 'Stav el. pen. $', value: 'stav_penezenky_dolar', sortable: false },
          { text: 'Stav el. pen. €', value: 'stav_penezenky_euro', sortable: false },
          { text: 'Bonus', value: 'bonus', sortable: false },
          { text: 'Zboží k předání', value: 'zbozi_k_predani', sortable: false },
          { text: 'Počet jedn. nákupů', value: 'pocet_jednorazovych_nakupu', sortable: false },
          { text: 'Počet post. nákupů', value: 'pocet_postupnych_nakupu', sortable: false },
          { text: 'Detail', value: null, sortable: false }
        ],
        items: [
          {
            jmeno: 'Jan Novák',
            mesto: "Praha",
            telefon: "+420 777 888 999",
            stav_penezenky_kc: "30 000 Kč",
            stav_penezenky_dolar: "1 500 $",
            stav_penezenky_euro: "1 100 €",
            bonus: "Lorem ipsum",
            zbozi_k_predani: "ANO",
            pocet_jednorazovych_nakupu: "22",
            pocet_postupnych_nakupu: "10"
          },
          {
            jmeno: 'Jan Novák',
            mesto: "Praha",
            telefon: "+420 777 888 999",
            stav_penezenky_kc: "30 000 Kč",
            stav_penezenky_dolar: "1 500 $",
            stav_penezenky_euro: "1 100 €",
            bonus: "Lorem ipsum",
            zbozi_k_predani: "ANO",
            pocet_jednorazovych_nakupu: "22",
            pocet_postupnych_nakupu: "10"
          },
          {
            jmeno: 'Jan Novák',
            mesto: "Praha",
            telefon: "+420 777 888 999",
            stav_penezenky_kc: "30 000 Kč",
            stav_penezenky_dolar: "1 500 $",
            stav_penezenky_euro: "1 100 €",
            bonus: "Lorem ipsum",
            zbozi_k_predani: "ANO",
            pocet_jednorazovych_nakupu: "22",
            pocet_postupnych_nakupu: "10"
          },
          {
            jmeno: 'Jan Novák',
            mesto: "Praha",
            telefon: "+420 777 888 999",
            stav_penezenky_kc: "30 000 Kč",
            stav_penezenky_dolar: "1 500 $",
            stav_penezenky_euro: "1 100 €",
            bonus: "Lorem ipsum",
            zbozi_k_predani: "ANO",
            pocet_jednorazovych_nakupu: "22",
            pocet_postupnych_nakupu: "10"
          }
        ]
      }
    }
  }
</script>
